import React from 'react'

import SingleLinePrice, {
  SingleLinePriceClientPricingItem,
} from './single-line-price/SingleLinePrice'
import { BillingColumns } from '../details-container/BillingColumns'
import { DescriptionMode } from '../details-container/DescriptionMode'

const LinePrices = (props: {
  className?: string
  displayMode?: DescriptionMode
  date?: Date
  columns: BillingColumns[]
  total?: {
    isTotal: boolean
    isTotalPerAdult: boolean
  }
  showAdjustments?: boolean
  hidePrice?: boolean
  emptyDate?: boolean
  clientPricingItem: SingleLinePriceClientPricingItem
  onClick?: (clientPricingItem: SingleLinePriceClientPricingItem) => void
  displayPrice?: boolean
}) => {
  return <SingleLinePrice {...props} />
}

export default LinePrices
